import { FilterModel } from './filter.model';
import { PaginationModel } from './pagination.model';
import { OrderModel } from './order.model';

export class SearchModel {
    filters: FilterModel[] = [];
    filtersDefault: FilterModel[] = [];
    pagination: PaginationModel;
    order: OrderModel;
}
